export default "__VITE_ASSET__d9447107__"